import { FC, useEffect } from 'react';
import { useWatch } from 'react-hook-form';

import { FormInput } from '../../../../../components/input/index';
import { FormTextEditor } from '../../../../../components/text-editor/index';
import { useReactForm } from '../../../../../hooks/index';
import { FormControlButtons } from '../components/form-control-buttons';
import { PerkFormSchema, perkFormSchema } from '../form.validation';
import { PerkStepFormProps } from './steps.types';

export const StepTwo: FC<PerkStepFormProps> = ({
  onSubmit,
  handlePrevStep,
  patchStep,
  defaultData: { stepTwo },
}) => {
  const {
    control,
    formState: { isValid },
    handleSubmit,
    reset,
  } = useReactForm({
    schema: perkFormSchema.shape.stepTwo,
  });

  useEffect(() => {
    if (!stepTwo) return;
    reset(stepTwo);
  }, [stepTwo, reset]);

  const submitHandler = (data: PerkFormSchema['stepTwo']) => {
    onSubmit('stepTwo', data);
  };

  const values = useWatch({ control });

  useEffect(() => {
    const id = setTimeout(() => {
      patchStep({ stepTwo: values });
    }, 500);

    return () => clearTimeout(id);
  }, [patchStep, values]);

  return (
    <>
      <div className="invisible-y-scroll flex h-full flex-col gap-4">
        <FormInput control={control} name="companySlogan" placeholder="Company’s Slogan" />
        <FormInput
          control={control}
          name="companyShortDescription"
          placeholder="Company’s Short Description"
        />
        <FormTextEditor
          control={control}
          label="Company Description"
          maxLength={700}
          name="companyDescription"
          placeholder="Company Description"
        />
      </div>

      <FormControlButtons
        disabled={!isValid}
        handleNext={handleSubmit(submitHandler)}
        handlePrev={handlePrevStep}
      />
    </>
  );
};
